interface ProbabilityEventBackgroundProps {
	variant?: 'default' | 'generate';
}

export function ProbabilityEventBackground({
	variant = 'default',
}: ProbabilityEventBackgroundProps) {
	if (variant === 'generate') {
		return (
			<div
				className="pointer-events-none absolute inset-0 -z-10"
				style={{
					background: 'linear-gradient(123.37deg, #FFFFFF 49.94%, #DCE3F9 100%)',
				}}
			/>
		);
	}

	return (
		<div className="pointer-events-none absolute inset-0 -z-10 overflow-hidden opacity-60">
			<div className="absolute inset-0" style={{ filter: 'blur(95.6px)' }}>
				{/* Pink/magenta glow - left edge, ~40% down */}
				<div
					className="absolute rounded-full"
					style={{
						left: '-10%',
						top: '33%',
						width: '48%',
						height: '25%',
						backgroundColor: '#8338EC',
						opacity: 0.6,
					}}
				/>
				{/* Lavender - top right */}
				<div
					className="absolute rounded-full"
					style={{
						left: '55%',
						top: '-8%',
						width: '55%',
						height: '25%',
						backgroundColor: '#A5B4FC',
						opacity: 0.7,
					}}
				/>
				{/* Faint lavender - top left */}
				<div
					className="absolute rounded-full"
					style={{
						left: '-8%',
						top: '-8%',
						width: '45%',
						height: '20%',
						backgroundColor: '#C4B5FD',
						opacity: 0.4,
					}}
				/>
				{/* Light blue - bottom center */}
				<div
					className="absolute rounded-full"
					style={{
						left: '15%',
						top: '68%',
						width: '65%',
						height: '30%',
						backgroundColor: '#60A5FA',
						opacity: 0.4,
					}}
				/>
				{/* Blue - bottom left */}
				<div
					className="absolute rounded-full"
					style={{
						left: '-15%',
						top: '78%',
						width: '50%',
						height: '25%',
						backgroundColor: '#4F46E5',
						opacity: 0.3,
					}}
				/>
				{/* Subtle indigo - bottom right */}
				<div
					className="absolute rounded-full"
					style={{
						left: '50%',
						top: '75%',
						width: '45%',
						height: '22%',
						backgroundColor: '#6366F1',
						opacity: 0.3,
					}}
				/>
			</div>
		</div>
	);
}
